module.exports = __webpack_public_path__ + "static/media/plus.85750da7.svg";